const FilterLine = ({ className, left, width }: any) => <i className={className} style={{ left: `${left}px`, width: `${width}px` }} />;

export default FilterLine;
